export default __webpack_public_path__ + "static/media/trailer-1-disney.a1c8252f.webp";